<script lang="ts">
import Close from "./icons/close-svg.svelte";
import ArrowForwardSvg from "./icons/arrow-forward-svg.svelte";
import ArrowRight from "../components/icons/arrow-right.svelte";
import type { Link } from "$lib/types";

export let venueLink: Link;

let isOpen = false;

function toggleMenu() {
	isOpen = !isOpen;

	if (isOpen) {
		document.body.style.overflow = "hidden";
	} else {
		document.body.style.overflow = "";
	}
}

$: navs = [
	{ text: "Balanced Bodyとは", href: "/about/" },
	{ text: "ブリッジ制度", href: "/otherschools/" },
	{ text: "コース", href: "/courses/" },
	{ text: "料金", href: "/prices/" },
	{ text: "スケジュール", href: "/schedule/" },
	{ text: "講師紹介", href: "/master-instructor/" },
	venueLink,
	{ text: "受講生の声", href: "/feedback/" },
	{ text: "フォローアップ", href: "/followup/" },
	{ text: "よくあるご質問", href: "/faq/" },
	{ text: "お知らせ", href: "/news/" },
];
</script>

<!-- ハンバーガーボタン -->
<button
  class="flex items-center"
  on:click={toggleMenu}
>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
    <path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z" fill="#5F6062" />
  </svg>
  <div class="text-sm text-textBalancedBodyGray ml-1">
    メニュー
  </div>
</button>

<!-- オーバーレイ -->
{#if isOpen}
  <button
    on:click={toggleMenu}
    class="fixed top-0 left-0 w-screen h-screen z-20"
    style="background-color: rgba(0, 0, 0, 0.5); transition: .3s;"
  />
{/if}

<!-- メニュー領域 -->
<div
  class="fixed top-0 w-[70vw] h-svh bg-white z-30"
  style="right: {isOpen ? '0' : '-70vw'}; transition: right .3s;"
>
  <div class="overflow-y-scroll w-full h-full pb-10">
    <!-- ヘッダー -->
    <div class="w-full h-[72px] border-b border-solid border-borderGray">
      <div class="flex items-center justify-between h-full px-4 sm:px-10">
        <div />
        <button
          class="flex items-center"
          on:click={toggleMenu}
        >
          <Close />
          <div class="text-sm ml-1">
            閉じる
          </div>
        </button>
      </div>
    </div>

    <!-- CTA -->
    <div class="mt-6 px-6">
      <a
        href="/contact/"
        target="_blank"
        class="border border-solid border-action rounded-lg flex items-center justify-between py-3 px-4 mb-4"
        on:click={toggleMenu}
      >
        <div class="text-sm text-action tracking-wide">
          質問や無料相談はこちら
        </div>
        <ArrowRight size={16} color="#4352F5" />
      </a>

      <a
        href="/entry/"
        target="_blank"
        class="border border-solid border-action bg-action text-white rounded-lg flex items-center justify-between py-3 px-4 mb-6"
        on:click={toggleMenu}
      >
        <div class="text-sm tracking-wide">
          受講を申し込む
        </div>
        <ArrowRight size={16} color="#fff" />
      </a>
    </div>

    <!-- ナビゲーション -->
    <ul class="text-base tracking-wide pt-2">
      {#each navs as { text, href }}
        <li class="py-4 px-7">
          <a
            href={href}
            class="flex items-center justify-between"
            on:click={toggleMenu}
          >
            <div class="text-sm tracking-wide">
              {text}
            </div>
            <ArrowForwardSvg size={16} />
          </a>
        </li>
      {/each}
    </ul>
  </div>
</div>